
import { BaseGroupType } from 'src/AngularJS/Models/group-type.model';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { Group } from 'src/AngularJS/Models/group.model';
import { GroupSelectorComponent } from 'src/app/reusables/group-selector/group-selector.component';
import { GroupSelectorDTO } from 'src/AngularJS/Reusables/group-selector.models';
import { isEqual, cloneDeep, uniqBy, intersectionWith } from 'lodash';
import { OmnibarComponent } from '@niceltd/cxone-components/omnibar';
import { PointStoreProductFilterService } from 'src/app/gamification/marketplace/admin/services/point-store-product-filter.service';
import { PointStoreProductOrderService } from 'src/app/gamification/marketplace/agent-side/services/point-store-product-order.service';
import moment from "moment";
import { AdminOrderReport, AdminOrderReportParams } from "src/AngularJS/Goals/Gamification/Models/admin-orders-report";
import { CxoneOrderManagementService } from "../../services/cxone-order-management.service";
import { MultiselectDropdownComponent } from '@niceltd/cxone-components/multiselect-dropdown';

interface Tag {
  id: number,
  name: string,
  type: string,
  parent?: number,
  loginId?: number,
}

enum TagType {
  STATUS = 'status',
  AGENT = 'agent',
  TEAM = 'team',
}

@Component({
  selector: 'cv-cxone-order-management',
  templateUrl: './cxone-order-management.component.html',
  styleUrl: './cxone-order-management.component.scss'
})
export class CxoneOrderManagementComponent implements OnInit {

  @ViewChild("groupSelectorDTOComp") groupSelectorDTOComp: GroupSelectorComponent;
  @ViewChild('filters') omnibarComponent: OmnibarComponent;
  @ViewChild('agentDropdown') agentDropdown: MultiselectDropdownComponent;
  @ViewChild('statusDropdown') statusDropdown: MultiselectDropdownComponent;

  pspos = null;
  selectedStatus: any[] = [];
  orderStatusList: any = {
    newValue: [],
    oldValue: []
  };
  countOrdersLabel: string = "";
  tagList: Tag[] = [];
  datePosition: any = {};
  pageName: string = 'PointStoreAdmin_temp';
  isFilterOpen: boolean = false;
  searchText: string = '';

  teamList: any = {
    newValue: [],
    oldValue: []
  };
  agentList: any = {
    newValue: [],
    oldValue: []
  };

  selectedTeam: Tag[] = [];
  selectedAgent: Tag[] = [];

  selectedAgentsDTO: GroupSelectorDTO = {
    ApplicationID: 0,
    PageName: this.pageName,
    SelectedGroupLevel: 1,
    SelectedGroupType: BaseGroupType.Employee,
    SelectedMinLevel: 1,
    SelectedMaxLevel: 3,
    _SelectedGroup1IDList: [0],
    _SelectedGroup2IDList: [0],
    _SelectedGroup3IDList: [0],
    _SelectedGroup4IDList: [0],
    _SelectedGroup5IDList: [0],
    ModuleRender: false,
    ShiftRender: false,
    AllSelected: false,
    toggleGroupData: false
  };

  get searchPlaceholder() {
    return this.cvLocalizationService.getCachedText("Order_Management", "Search_Orders_Input", "Search orders");
  }

  constructor(
    private pointStoreProductOrderService: PointStoreProductOrderService,
    public cvConfigurationService: CvConfigurationService,
    private pointStoreProductFilterService: PointStoreProductFilterService,
    public cvLocalizationService: CVLocalizationService,
    private orderManagementService: CxoneOrderManagementService,
    private changeDetectorRef: ChangeDetectorRef

  ) {
    this.cvConfigurationService.isCxOne = true;
  }

  async ngOnInit() {
    this.pspos = this.pointStoreProductOrderService.pointStoreProductOrderObj;
    await this.cvLocalizationService.GetSection("Order_Management");
    await this.pointStoreProductOrderService.loadOrderStatusName();
    await this.pointStoreProductOrderService.loadOrdersPlacedIn();
    this.loadLocalizations();
    await this.pointStoreProductOrderService.LoadPointStoreProductAdminOrders(true);
    this.pointStoreProductOrderService.filterOrderRecordsByYear();
    this.datePosition = this.pspos.pointStoreProductAdminOrderFilter.dateCXOne[0];
  }

  setCountOrdersLabel(event): void {
    const placeholder = event === 1 ?
      this.cvLocalizationService.getCachedText("Order_Management", "Orders_Single_Placeholder", "order") :
      this.cvLocalizationService.getCachedText("Order_Management", "Orders_Placeholder", "orders");
    this.countOrdersLabel = `${event} ${placeholder}`;
  }

  onTitleFilterChange(searchText: string): void {
    this.pspos.pointStoreProductAdminOrderFilter.searchOrder = searchText;
    this.searchText = searchText;
  }

  selectionChangedStatus(): void {
    const formattedStatusList = this.selectedStatus.map((status) => {
      return {
        id: status.value,
        name: status.name,
        type: TagType.STATUS,
      }
    });
    //reset status and keep agents and teams
    this.tagList = this.tagList.filter(tag => tag.type === TagType.AGENT || tag.type === TagType.TEAM);
    this.tagList = [...this.tagList, ...formattedStatusList];
    this.updateFilterStatus();
  }

  selectionChangedDatePosition(): void {
    this.pspos.pointStoreProductAdminOrderFilter.datePosition = this.datePosition.position;
  }

  /**
   * method for reset all the filters
   */
  clearFilters() {
    //reset dropdowns
    this.selectedStatus = [];
    this.tagList = [];
    this.selectedAgent = [];
    this.selectedTeam = [];
    this.agentList.newValue = this.agentList.oldValue;
    this.teamList.newValue = this.teamList.oldValue;
    this.orderStatusList.newValue = this.orderStatusList.oldValue;
    //reset filter
    const newFilter = this.pointStoreProductFilterService.getNewAdminOrderFilter();
    //translate dates objects
    newFilter.dateCXOne.forEach((date) => {
      date.name = this.cvLocalizationService.getCachedText("MarketPlace_Management_Filter", date.keyLocalization, date.name);  
    });
    this.pspos.pointStoreProductAdminOrderFilter = {...newFilter};
    this.selectionChangedDatePosition();
    this.onTitleFilterChange(this.searchText);
    setTimeout(() => {
      this.pspos.pointStoreProductAdminOrderFilter.groupSelectorChanged = true;
      this.pspos.pointStoreProductAdminOrderFilter.resetFilter = true;
    }, 200);
    this.pointStoreProductOrderService.filterOrderRecordsByYear();
  }

  /**
   * method for reset the group selector
   */
  async resetGroupSelector() {
    const oldSelectedGroupsDto = cloneDeep(this.groupSelectorDTOComp.selectedGroupsDto);
    this.updateGroupSelectors(oldSelectedGroupsDto);
    this.groupSelectorDTOComp.selectedGroupsDto.SelectedGroupLevel = 1;
    this.groupSelectorDTOComp.selectedGroupsDto._SelectedGroup1IDList = [0];
    this.groupSelectorDTOComp.selectedGroupsDto._SelectedGroup2IDList = [0];
    await this.triggerSelectGroupChange();
  }

  /**
   * method for close the omnibar filter section
   */
  closeFilters(): void {
    this.omnibarComponent.toggleFiltersSection();
  }

  /**
   * remove tag by type
   * @param event item
   */
  async remove(event: Tag) {
    const oldSelectedGroupsDto = cloneDeep(this.groupSelectorDTOComp.selectedGroupsDto);
    switch (event.type) {
      case TagType.STATUS:
        const removedStatus = this.selectedStatus.filter(status => status.value !== event.id);
        this.selectedStatus = removedStatus;
        this.updateFilterStatus();
        break;
      case TagType.AGENT:
        this.updateGroupSelectors(oldSelectedGroupsDto);
        const removedAgent = this.groupSelectorDTOComp.selectedGroupsDto._SelectedGroup1IDList.filter(id => id !== event.id);
        this.groupSelectorDTOComp.selectedGroupsDto._SelectedGroup1IDList = removedAgent;
        await this.triggerSelectGroupChange();
        break;
      case TagType.TEAM:
        this.updateGroupSelectors(oldSelectedGroupsDto);
        const removedTeam = this.groupSelectorDTOComp.selectedGroupsDto._SelectedGroup2IDList.filter(id => id !== event.id);
        this.groupSelectorDTOComp.selectedGroupsDto._SelectedGroup2IDList = removedTeam;
        await this.triggerSelectGroupChange();
        break;
      default:
        break;
    }
  }

  /**
   * update the value for group selector
   */
  async triggerSelectGroupChange() {
    await this.groupSelectorDTOComp.updateSelectorsFromDTO();
    this.groupSelectorDTOComp.selectedGroupsChanged.emit(this.groupSelectorDTOComp.selectedGroupsDto);
  }

  async onEmpGroupsChanged(event: GroupSelectorDTO) {
    if (isEqual(event, this.selectedAgentsDTO)) {
      return;
    }
    this.updateGroupSelectors(event);
    let selectedLevel: number = this.groupSelectorDTOComp.lastLevelChanged;
    this.pspos.pointStoreProductAdminOrderFilter.gLvl = selectedLevel;
    this.pspos.pointStoreProductAdminOrderFilter.gIDs = this.getIdsFromSelectedLevel(selectedLevel, event);
    this.pspos.pointStoreProductAdminOrderFilter.gType = event.SelectedGroupType;

    if (this.pspos.pointStoreProductAdminOrderFilter.empGroup == undefined) {
      this.pspos.pointStoreProductAdminOrderFilter.empGroup = [];
    }
    if (this.pspos.pointStoreProductAdminOrderFilter.empGroup.length) {
      for (let index = 1; index < this.pspos.pointStoreProductAdminOrderFilter.empGroup.length; index++) {
        if (this.pspos.pointStoreProductAdminOrderFilter.empGroup[index] == null) {
          this.pspos.pointStoreProductAdminOrderFilter.empGroup[index] = ["0"];
        }
      }
    }
    let filterChanged = (this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel].length == this.pspos.pointStoreProductAdminOrderFilter.gIDs.length)
      && this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel].every((element, index) => element === this.pspos.pointStoreProductAdminOrderFilter.gIDs[index].toString());

    if (!filterChanged) {
      this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel] = this.pspos.pointStoreProductAdminOrderFilter.gIDs.map((group: number) => { return group.toString() });
    }

    this.addAgentsOrTeamsToTags();
    await this.pointStoreProductOrderService.LoadPointStoreProductAdminOrders(true);
  }

  getIdsFromSelectedLevel(selectedLevel: number, dto: GroupSelectorDTO): number[] {
    let selectedIds: number[] = [];
    switch (selectedLevel) {
      case 1:
        selectedIds = dto._SelectedGroup1IDList;//agents
        break;
      case 2:
        selectedIds = dto._SelectedGroup2IDList;//teams
        break;
      default:
        break;
    }
    return selectedIds;
  }

  /**
   * update the value for the status filter
   */
  updateFilterStatus(): void {
    const formattedStatus = this.tagList?.filter((tag: Tag) => tag.type === TagType.STATUS)
      .map((tag: Tag) => tag.id);
    this.pspos.pointStoreProductAdminOrderFilter.SelectedStatuses = formattedStatus || [];
  }

  /**
   * 
   * @param groupSelectorDTO 
   */
  async initialGroupsLoaded(groupSelectorDTO: GroupSelectorDTO) {
    this.updateGroupSelectors(groupSelectorDTO);
    let selectedLevel: number = 2;
    this.pspos.pointStoreProductAdminOrderFilter.gLvl = selectedLevel;
    this.pspos.pointStoreProductAdminOrderFilter.gIDs = this.getIdsFromSelectedLevel(selectedLevel, groupSelectorDTO);
    this.pspos.pointStoreProductAdminOrderFilter.gType = groupSelectorDTO.SelectedGroupType;

    if (this.pspos.pointStoreProductAdminOrderFilter.empGroup == undefined) {
      this.pspos.pointStoreProductAdminOrderFilter.empGroup = [];
    }
    if (this.pspos.pointStoreProductAdminOrderFilter.empGroup.length) {
      for (let index = 1; index < this.pspos.pointStoreProductAdminOrderFilter.empGroup.length; index++) {
        if (this.pspos.pointStoreProductAdminOrderFilter.empGroup[index] == null) {
          this.pspos.pointStoreProductAdminOrderFilter.empGroup[index] = ["0"];
        }
      }
    }
    let filterChanged = (this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel].length == this.pspos.pointStoreProductAdminOrderFilter.gIDs.length)
      && this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel].every((element, index) => element === this.pspos.pointStoreProductAdminOrderFilter.gIDs[index].toString());

    if (!filterChanged) {
      this.pspos.pointStoreProductAdminOrderFilter.empGroup[selectedLevel] = this.pspos.pointStoreProductAdminOrderFilter.gIDs.map((group: number) => { return group.toString() });
    }

    await this.pointStoreProductOrderService.LoadPointStoreProductAdminOrders(true);
    this.pointStoreProductOrderService.filterOrderRecordsByYear();
  }

  /**
   * method to update the selectedAgentsDTO with the current selection retrieve by the component
   * @param groupSelectorDTO 
   */
  private updateGroupSelectors(groupSelectorDTO: GroupSelectorDTO): void {
    this.selectedAgentsDTO = groupSelectorDTO;
  }

  /**
   * method to add teams or agents to tags
   */
  addAgentsOrTeamsToTags(): void {
    const groupByLevel = this.groupSelectorDTOComp.groupsByLevel;
    const lastLevelChanged: number = this.groupSelectorDTOComp.lastLevelChanged;
    const currentSelection = this.groupSelectorDTOComp.selectedGroups;

    switch (lastLevelChanged) {
      case 1:
        //keep status, teams and replace agents with currentSelection
        this.tagList = this.tagList.filter((tag: Tag) => tag.type === TagType.STATUS || tag.type === TagType.TEAM);
        const agentInfoList: Tag[] = this.retrieveGroupInfoById(currentSelection[1], groupByLevel[1].Groups).map((agent) => {
          return {
            id: agent.Group1ID,
            name: agent.GroupName,
            type: TagType.AGENT,
            parent: agent.Group2ID
          }
        });
        this.tagList = [...this.tagList, ...agentInfoList];
        break;
      case 2:
        //keep status, agents and replace teams with currentSelection
        const teamsSelected : Set<number> = new Set(currentSelection[2] || []) 
        this.tagList = this.tagList.filter((tag: Tag) => tag.type === TagType.STATUS || (tag.type === TagType.AGENT && teamsSelected.has(tag.parent)));
        const teamsInfoList: Tag[] = this.retrieveGroupInfoById(currentSelection[2], groupByLevel[2].Groups).map((team) => {
          return {
            id: team.Group2ID,
            name: team.GroupName,
            type: TagType.TEAM,
          }
        });

        this.tagList = [...this.tagList, ...teamsInfoList];
        break;
      default:
        break;
    }
  }

  /**
   * 
   * @param ids group ids selected by the empgroup
   * @param group full group obj info retrieve by api
   * @returns 
   */
  retrieveGroupInfoById(ids: number[], group: Group[]): Group[] {
    return ids.map(id => group.find((item) => item.GroupID === id))
  }
  
  loadLocalizations() {
    this.cvLocalizationService.GetSection("MarketPlace");
    this.cvLocalizationService.GetSection("Order_Management");
  }

  productTextString(products: any[]): string {
    let productsText: string = '';
    if (products) {
      for (let index = 0; index < products.length; index++) {
        const variationName = products[index]._PointStoreProductOrderedDTO.VariationName;
        productsText += products[index]._PointStoreProductOrderedDTO.ProductQuantity;
        productsText += " ";
        productsText += products[index]._PointStoreProductOrderedDTO.Title;
        productsText += products[index]._PointStoreProductOrderedDTO.VariationName != "" ? " - " + (!variationName ? 'N/A' : variationName) + " (" : " (";
        productsText += products[index]._PointStoreProductOrderedDTO.ProductCost;
        productsText += ` ${this.cvLocalizationService.getCachedText("MarketPlace", "Coins_Each", "Coins")})`;
        if (index + 1 < products.length) {
          productsText += ", ";
        }
      }
    }
    return productsText;
  }

  async exportOrdersTable() {
    const dataFiltered: AdminOrderReport[] = this.pspos.dataFiltered.map(({ ...orders }) => {
      const status = this.pspos.OrderStatus.find(status => status.value === orders.OrderStatus);
      return {
        Team: orders.RelatedParentGroupName,
        OrderNumber: orders.PointStoreOrderID,
        OrderBy: orders.LoginName,
        AgentId: orders.LoginID,
        DateOrdered: moment(orders.DateOrdered).format('MM/DD/YYYY'),
        TotalCoins: orders.OrderTotal,
        Status: status.name,
        Notes: orders.Note,
        ProductsText: this.productTextString(orders.ProductsCollection),
        RelatedGroupID: orders.RelatedGroupID,
        RelatedGroupLevel: orders.RelatedGroupLevel
      }
    });

    //selected status param
    const adminOrderFilter = this.pspos.pointStoreProductAdminOrderFilter;
    const selections: [] = !adminOrderFilter.SelectedStatuses ? [] : adminOrderFilter.SelectedStatuses;
    const selectedStatuses = [];
    for (let i = 0; i < this.pspos.OrderStatus.length; i++) {
      if (selections.length > 0 && selections.length < 6) {
        selectedStatuses[i] = !!adminOrderFilter.SelectedStatuses.find(x => x === i + 1);
      } else {
        selectedStatuses[i] = true;
      }
    }

    //loadGroupSelector
    const params: AdminOrderReportParams = {
      StatusValues: selectedStatuses,
      DatePosition: adminOrderFilter.datePosition,
      OrderBy: this.pspos.sortAdminBy,
      Reverse: this.pspos.sortAdminReverse,
      FilterCustomInput: adminOrderFilter.searchOrder,
      format: "excel",  
      AdminOrderReportList: dataFiltered,
    }

    // ADD CXONE CONFIG IN SECOND PARAM
    const data = await this.pointStoreProductOrderService.buildAdminOrdersReport(params, true, false);
    if (data) {
      const currentDate: string = moment().format('DD MMM, YYYY h:mm:ss A');
      const formattedDate: string[] = currentDate.split(' ');
      const formattedDateTime: string[] = formattedDate[3].split(':');
      const dateTimeSplitted: string = formattedDateTime[0] + 'h' + formattedDateTime[1] + 'm' + formattedDateTime[2] + 's ';
      const fileName = "MarketplaceOrderHistory_" + formattedDate[0] + ' ' + formattedDate[1] + formattedDate[2] + ' ' + dateTimeSplitted + formattedDate[4] + ".xlsx";
      this.downloadFile(data, "excel", fileName);
    }
  }
  /**
      * Downloads a file from a byte array string
      *
      * @param {string} data The byte[] string returned from the endpoint
      * @param {string} mime The mime type to mark the file as
      * @param {string} fileName The name of the file to be downloaded
      * @memberof ModuleContainerComponent
      */
  downloadFile(data, mime, fileName) {
    var decodedData = atob(data);
    var buffer = new ArrayBuffer(decodedData.length);
    var view = new Uint8Array(buffer);
    for (var i = 0; i != decodedData.length; ++i) {
      view[i] = decodedData.charCodeAt(i) & 0xFF;
    }

    var fileData = [buffer];
    var blobObject = new Blob(fileData, { type: mime });
    // non-IE
    // create fake link
    var linkElement = document.createElement('a');
    document.body.appendChild(linkElement);
    linkElement.setAttribute('style', 'display: none;');
    var url = URL.createObjectURL(blobObject);
    linkElement.href = url;
    linkElement.download = fileName;

    // start download
    linkElement.click();

    // cleanup
    URL.revokeObjectURL(linkElement.href);
    linkElement.remove();
  };

  setGroupSelectorData(event) {
    this.teamList = event.get('teams');
    this.agentList = event.get('agents');
    this.orderStatusList = event.get('status');
    const selectedStatusUpdated = intersectionWith(this.orderStatusList.newValue, this.selectedStatus, isEqual);
    if (this.selectedStatus?.length > 0) {
      this.statusDropdown.selection = selectedStatusUpdated;
      this.selectedStatus = this.statusDropdown.selection;
      this.selectionChangedStatus();
    }
    this.changeDetectorRef.detectChanges();
  }

  selectionChangedTeam() {
    if (!this.teamList.newValue.length) {
      return;
    }

    if (this.selectedTeam?.length === 0) {
      this.pspos.pointStoreProductAdminOrderFilter.groupSelectorEmtpy = true;
    }
    this.updateAgentDropdown();
    this.addTeamOrAgentToTags(TagType.TEAM);
    this.setEmpGroupFilter(1, this.selectedAgent.length === 0 ? [-2] : this.selectedAgent.map(agent => agent.id), this.getSelectedAgentLogins(this.selectedAgent));
    this.setEmpGroupFilter(2, this.selectedTeam.map((team) => team.id));
  }

  selectionChangedAgent() {
    if (this.agentList.newValue?.length === 0) {
      return;
    }

    if (this.selectedAgent?.length === 0) {
      this.pspos.pointStoreProductAdminOrderFilter.groupSelectorEmtpy = true;
    }

    this.addTeamOrAgentToTags(TagType.AGENT);
    this.setEmpGroupFilter(1, this.selectedAgent.length === 0 ? [-2] : this.selectedAgent.map(agent => agent.id), this.getSelectedAgentLogins(this.selectedAgent));
  }

  /**
   * 
   * @param event 
   */
  removeTag(event: Tag) {
    let callFilter: boolean = false
    switch (event.type) {
      case TagType.STATUS:
        const removedStatus = this.selectedStatus.filter(status => status.value !== event.id);
        this.selectedStatus = removedStatus;
        this.updateFilterStatus();
        break;
      case TagType.AGENT:
        const removedAgent = this.selectedAgent.filter(agent => agent.loginId !== event.loginId);
        this.selectedAgent = removedAgent;
        callFilter = true;
        break;
      case TagType.TEAM:
        const removedTeam = this.selectedTeam.filter(team => team.id !== event.id);
        this.selectedTeam = removedTeam;
        this.updateAgentDropdown();
        this.addTeamOrAgentToTags(TagType.TEAM);
        callFilter = true;
        break;
      default:
        break;
    }

    if (callFilter) {
      this.setEmpGroupFilter(1, this.selectedAgent.length === 0 ? [-2] : this.selectedAgent.map(agent => agent.id), this.getSelectedAgentLogins(this.selectedAgent));
      this.setEmpGroupFilter(2, this.selectedTeam.map((team) => team.id));
    }
  }

  addTeamOrAgentToTags(type: TagType) {
    switch (type) {
      case TagType.AGENT:
        //keep status, teams and replace agents with currentSelection
        this.tagList = this.tagList.filter((tag: Tag) => tag.type === TagType.STATUS || tag.type === TagType.TEAM);
        const agents = new Set(this.selectedAgent.map(agent => agent.loginId) ?? []);
        const agentInfoList: Tag[] = this.agentList.oldValue.filter(agent => agents.has(agent.loginId)).map((agent) => {
          return {
            id: agent.id,
            name: agent.name,
            type: TagType.AGENT,
            parent: agent.parent,
            loginId: agent.loginId,
          }
        });
        this.tagList = [...this.tagList, ...agentInfoList];
        break;
      case TagType.TEAM:
        //if a team is deselected and there are associated agents in the tags, they will be removed.
        const teamsIds: Set<number> = this.convertToSet(this.selectedTeam);
        this.tagList = this.tagList.filter((tag: Tag) => tag.type === TagType.STATUS || (tag.type === TagType.AGENT && teamsIds.has(tag.parent)));
        const teamsInfoList: Tag[] = this.selectedTeam.map((team) => {
          return {
            id: team.id,
            name: team.name,
            type: TagType.TEAM,
          }
        });
        this.tagList = [...this.tagList, ...teamsInfoList];
        break;
      default:
        break;
    }
  }

  convertToSet(list: any[]): Set<number> {
    return new Set(list.map(o => o.id) ?? []);
  }

  updateAgentDropdown() {
    if (this.selectedTeam.length !== 0) {
      const teams = this.convertToSet(this.selectedTeam);
      this.agentList.newValue = this.agentList.oldValue.filter(agent => teams.has(agent.parent));
      const newAgents = this.convertToSet(this.agentList.newValue);
      this.selectedAgent = this.selectedAgent.filter(agent => newAgents.has(agent.id));
      this.agentDropdown.selection = this.selectedAgent;
      this.agentDropdown.options = this.agentList.newValue;
    } else {
      this.agentList.newValue = this.agentList.oldValue;
      this.selectedAgent = [];
      this.agentDropdown.options = this.agentList.newValue;
    }
  }

  /**
   * The loginId prop is added to distinguish between agents that have the same Group1ID or linked group data.
   * @param selectedAgents current agents
   * @returns 
   */
  getSelectedAgentLogins(selectedAgents: Tag[]) {
    const loginIds = new Set(selectedAgents.map(o => o.loginId) ?? []);
    return selectedAgents.length === 0 ? [-2] : this.agentList.newValue.filter(agent => loginIds.has(agent.loginId))
      .map(agent => agent.loginId);
  }

  setEmpGroupFilter(selectedLevel: number, selectedGroup: number[], selectedLogins: number[] = [-2]) {
    this.pspos.pointStoreProductAdminOrderFilter.gLvl = selectedLevel;
    this.pspos.pointStoreProductAdminOrderFilter.gIDs = selectedGroup;
    this.pspos.pointStoreProductAdminOrderFilter.gType = 0;

    if (this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne == undefined) {
      this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne = [];
    }
    if (this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne.length) {
      for (let index = 1; index < this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne.length; index++) {
        if (this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne[index] == null) {
          this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne[index] = ["-2"];
        }
      }
    }
    let filterChanged = (this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne[selectedLevel].length == this.pspos.pointStoreProductAdminOrderFilter.gIDs.length)
      && this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne[selectedLevel].every((element, index) => element === this.pspos.pointStoreProductAdminOrderFilter.gIDs[index].toString());

    if (!filterChanged) {
      this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne[selectedLevel] = this.pspos.pointStoreProductAdminOrderFilter.gIDs.map((group: number) => { return group.toString() });
      if(selectedLevel === 1) {
        //just for cxone all the loginIds are added to the array in the 3 position
        this.pspos.pointStoreProductAdminOrderFilter.empGroupCXOne[3] = selectedLogins.map((logins: number) => { return logins.toString() });
      }
    }
    this.pspos.pointStoreProductAdminOrderFilter.groupSelectorChanged = true;
  }
};